exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".vux-modal-open {\r\n  overflow: hidden;\r\n  position: fixed;\r\n  width: 100%;\r\n}\r\n.vux-modal-open-for-container {\r\n  overflow: hidden!important;\r\n}\r\n", "", {"version":3,"sources":["/root/workspace/__flow_work/__flow_builds/cb933383-c455-4793-a962-5fc79d01142f/workspace/code/Original-Life-Mobile/node_modules/vux/src/styles/vux-modal.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;CACb;AACD;EACE,2BAA2B;CAC5B","file":"vux-modal.css","sourcesContent":[".vux-modal-open {\r\n  overflow: hidden;\r\n  position: fixed;\r\n  width: 100%;\r\n}\r\n.vux-modal-open-for-container {\r\n  overflow: hidden!important;\r\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vux/src/styles/vux-modal.css
// module id = 198
// module chunks = 41